var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditCarePlanIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 1.66699H6.6665C3.33317 1.66699 1.6665 3.33366 1.6665 6.66699V17.5003C1.6665 17.9587 2.0415 18.3337 2.49984 18.3337H13.3332C16.6665 18.3337 18.3332 16.667 18.3332 13.3337V6.66699C18.3332 3.33366 16.6665 1.66699 13.3332 1.66699Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7583 6.53346L6.43332 10.8585C6.26666 11.0251 6.10833 11.3501 6.07499 11.5835L5.84166 13.2335C5.75833 13.8335 6.17499 14.2501 6.77499 14.1668L8.42498 13.9335C8.65831 13.9001 8.98333 13.7418 9.15 13.5751L13.475 9.25013C14.2167 8.50846 14.575 7.64179 13.475 6.54179C12.375 5.43346 11.5083 5.78346 10.7583 6.53346Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1416 7.15039C10.5083 8.45872 11.5333 9.49206 12.8499 9.85872",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCarePlanIcon);
export default __webpack_public_path__ + "static/media/edit_care_plan_icon.a7512d42cb0f22d9099c69e99c507822.svg";
export { ForwardRef as ReactComponent };